import FormUpload from './form-upload';

export default angular.module('webPublicClient.creditRequest.shared.services', [
])
.service('formUpload', FormUpload);


// WEBPACK FOOTER //
// ./src/credit-request/shared/services/index.js